import { isGlassisMainPeriod } from '@/features/promotion/constants'
import { Locales } from '@/utils/language'

export interface SEOMeta {
  title?: string
  description?: string
  image?: string
  locale?: string
  type?: string
  siteName?: string
  robots?: string
  twtCardType?: string
  ogDescription?: string
  ogImage?: string
  ogTitle?: string
  ogUrl?: string
  canonical?: string
}

const metaByLocale: Record<Locales, SEOMeta> = {
  [Locales.KO_KR]: {
    description:
      '국내 1위 미용의료앱 강남언니. 리얼후기부터 가격비교, 상담예약까지 한번에. 강남언니를 지금 만나보세요.',
    image: 'https://www.gangnamunni.com/images/kr/meta_thumb.webp',
    locale: 'ko_KR',
    title: '강남언니 - 1등 성형수술&피부시술 정보앱',
    twtCardType: 'summary_large_image',
    type: 'website',
  },
  [Locales.JA_JP]: {
    title: 'カンナムオンニ｜国内利用者数No.1美容医療・整形の口コミ予約アプリ',
    description:
      '美容医療・美容整形・医療脱毛・審美歯科の美容外科・美容皮膚科・美容クリニックをオンラインで簡単に予約。「価格」「リアルな口コミ」「経過・ダウンタイム」「症例」すべて見られる',
    image: 'https://www.gangnamunni.com/images/jp/meta_thumb_02.jpg',
    locale: 'ja_JP',
    twtCardType: 'summary_large_image',
    type: 'website',
  },
  [Locales.EN_US]: {
    description: '',
    image: '',
    locale: '',
    title: '',
    twtCardType: '',
    type: '',
  },
  [Locales.TH_TH]: {
    title: 'UNNI | แอปทำสวยอันดับ1 ของเกาหลี',
    description: 'รวมรีวิวจริงกว่า 3ล้านรีวิว ดูโปรฯ เทียบราคา ปรึกษาและจองกับคลินิกชื่อดังในเกาหลีได้ง่ายๆ ที่ UNNI',
    image: '',
    locale: 'th_TH',
    twtCardType: 'summary_large_image',
    type: 'website',
  },
  [Locales.ZH_HANS_CN]: {
    description: '',
    image: '',
    locale: '',
    title: '',
    twtCardType: '',
    type: '',
  },
  [Locales.ZH_HANT_TW]: {
    description: '',
    image: '',
    locale: '',
    title: '',
    twtCardType: '',
    type: '',
  },
}

export function getDefaultMeta(
  locale: Locales,
  override?: Partial<SEOMeta> | ((meta: Partial<SEOMeta>) => SEOMeta),
): SEOMeta {
  const defaultMeta = metaByLocale[locale]
  if (isGlassisMainPeriod() && locale === Locales.KO_KR) {
    defaultMeta.image = 'https://www.gangnamunni.com/images/kr/og_glassis.webp'
  }
  const defaultOgMeta = {
    ogDescription: defaultMeta?.description || '',
    ogImage: defaultMeta?.image || '',
    ogTitle: defaultMeta?.title || '',
    ogUrl: defaultMeta?.canonical || '',
  }
  return {
    ...defaultMeta,
    ...defaultOgMeta,
    ...(typeof override === 'function' ? override(defaultMeta) : override),
  }
}
